import { EntitlementLevel } from '.';

export const groupLevelExists = (group: string[], levels: EntitlementLevel[]): boolean => {
  if (!Array.isArray(group) || !Array.isArray(levels)) {
    return false;
  }
  return levels.some((level) => {
    if (level === EntitlementLevel.any) {
      return group.length;
    } else {
      return group.some((groupLevel) => {
        switch (level) {
          case EntitlementLevel.anyGrant:
            return groupLevel.includes(EntitlementLevel.grant);
          case EntitlementLevel.anyRead:
            return groupLevel.includes(EntitlementLevel.read);
          case EntitlementLevel.anyUse:
            return groupLevel.includes(EntitlementLevel.use);
          default:
            return groupLevel === level;
        }
      });
    }
  });
};

export const groupExists = (groupsData: any): boolean => {
  const userInformation = groupsData.userInformation;
  const privNameMap = groupsData.privNameMap;
  // the userInfo endpoint returns differently per realm
  if (groupsData.currentEnv.identityProviderRealm === 'isso') {
    return groupsData.groups.some((group: string) =>
      userInformation?.groups.includes(privNameMap[group.toLowerCase()]),
    );
  } else {
    return groupsData.groups.some((group: any) => {
      if (typeof group === 'string') {
        if (group.toLocaleUpperCase() === 'PUBLIC') {
          return userInformation?.['nasdOrgClass']?.includes('PUBLIC');
        } else {
          const userGroup = userInformation?.[privNameMap[group.toLowerCase()]];
          return userGroup
            ? groupLevelExists(userInformation?.[privNameMap[group.toLowerCase()]], [EntitlementLevel.anyUse])
            : false;
        }
      } else if (typeof group === 'object') {
        const userGroup = userInformation?.[privNameMap[group.name.toLowerCase()]];
        return userGroup
          ? groupLevelExists(userInformation?.[privNameMap[group.name.toLowerCase()]], group.levels)
          : false;
      }
    });
  }
};
